export const filterFieldProperties = (key) => {
    return (!key.startsWith('_') &&
        ![
            'id'
            // 'username'
        ].includes(key));
};
